import { CafeBazaar } from './types';

const useCafeBazaar = (): CafeBazaar => {
  return {
    subscribePlan: async () => undefined,
    subscribedPlans: [],
    getSubscribedPlan: async (..._args: any[]) => [],
    handleSubscribe: async (..._args: any[]) => undefined,
  };
};

export default useCafeBazaar;
